module.exports = __webpack_public_path__ + "img/payoneer.c2176a2b.svg";